import React from "react";

const Actionbreak = ({ stats, loading }) => {
  const walletCounts = stats?.sentToWalletUserCount || [];
  const claimedCount = walletCounts.find((x) => x._id === "claimed_usdt")?.count || 0;
  const bothCount = walletCounts.find((x) => x._id === "both")?.count || 0;
  const exitCompleted = stats?.exitCompleted?.[0]?.exitCompleted || 0;
  const totalEligible = stats?.totalUsersEligible?.[0]?.totalUsersEligible || 0;
  const boughtKaiCount = Math.max(0, exitCompleted - claimedCount - bothCount);
  const notYetCount = Math.max(0, totalEligible - exitCompleted);

  const ACTION_ITEMS = [
    { key: "claimed", color: "blue", count: claimedCount, label: "Claimed USDT" },
    { key: "boughtkai", color: "green", count: boughtKaiCount, label: "Bought KAI" },
    { key: "bothkai", color: "orange", count: bothCount, label: "Bought (KAI + payout)" },
    { key: "notyet", color: "dull", count: notYetCount, label: "Not yet acted" },
  ];

  const hasData = !loading && stats;

  return (
    <div className="actioncard">
      <div className="actiontop">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M9 11V20M9 11H4.59961C4.03956 11 3.75981 11 3.5459 11.109C3.35774 11.2049 3.20487 11.3577 3.10899 11.5459C3 11.7598 3 12.04 3 12.6001V20H9M9 11V5.6001C9 5.04004 9 4.75981 9.10899 4.5459C9.20487 4.35774 9.35774 4.20487 9.5459 4.10899C9.75981 4 10.0396 4 10.5996 4H13.3996C13.9597 4 14.2403 4 14.4542 4.10899C14.6423 4.20487 14.7948 4.35774 14.8906 4.5459C14.9996 4.75981 15 5.04005 15 5.6001V8M9 20H15M15 20L21 20.0001V9.6001C21 9.04005 20.9996 8.75981 20.8906 8.5459C20.7948 8.35774 20.6429 8.20487 20.4548 8.10899C20.2409 8 19.9601 8 19.4 8H15M15 20V8" stroke="#02171D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <p className="actionpara">
          Action Break
          <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
            <circle cx="2" cy="2" r="2" fill="#77868B" />
          </svg>
          eligible cohort
        </p>
      </div>

      <div className="actionbar">
        {hasData
          ? ACTION_ITEMS.map((item) =>
              item.count > 0 ? (
                <div key={item.key} className={`actionbar-segment ${item.color}`} style={{ flex: item.count }} />
              ) : null
            )
          : <div className="actionbar-segment dull" style={{ flex: 1 }} />}
      </div>

      <div className="actionbottom">
        {ACTION_ITEMS.map((item) => (
          <div key={item.key} className="inneraction">
            <span className={`line ${item.color}`}></span>
            <h6 className="innerpara">
              <span className="black">{hasData ? item.count : "—"}</span> {item.label}
            </h6>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Actionbreak;
